import Authorization from './Login/Authorization';
import {useState} from '../app3';
import airgram from '../airgram';
import Auth from '../Auth';
import AuthCode from './Login/AuthCode';
import Messenger from './Messenger';

function createDeferred() {
  const deferred = {
    resolve: null,
    reject: null,
    promise: null,
  };

  deferred.promise = new Promise((resolve, reject) => {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });

  return deferred;
}

export default function App() {
  const [state, patch] = useState({
    currentFrame: 0,
    deferred: createDeferred(),
    isLoading: true,
  });

  airgram.use(new Auth({
    phone(authState) {
      const deferred = createDeferred();

      patch({
        currentFrame: 0,
        isLoading: false,
        deferred,
      });

      return deferred.promise;
    },
    code() {
      const deferred = createDeferred();

      patch({
        currentFrame: 1,
        isLoading: false,
        deferred,
      });

      return deferred.promise;
    },
    ready() {
      const deferred = createDeferred();

      patch({
        currentFrame: 100,
        isLoading: false,
        deferred,
      })
    }
  }));

  function handleNextClick(e, frameData) {
    state.deferred.resolve(frameData);

    patch({
      isLoading: true,
    });
  }

  return h => {
    let children = [];
    let loading = null;

    if (state.isLoading) {
      loading = h('span', String('IS LOADING'));

      children.push(loading);
    } else {
      switch (state.currentFrame) {
        case 0: {
          children.push(h(Authorization, {
            key: 'login',
            props: {
              handleNextClick,
            },
          }));
          break;
        }
        case 1: {
          children.push(h(AuthCode, {
            key: 'code',
            props: {
              handleNextClick,
            },
          }));
          break;
        }
        case 100: {
          children.push(h(Messenger, {
            key: 'messenger',
          }))
        }
      }
    }
    console.log(children);

    return h('div', {
      attrs: {
        id: 'app',
      },
      // on: {
      //   click: () => {
      //     state.deferred.resolve('+79060488721')
      //   },
      // },
      children,
    })
  }
}
